import SinglePageLayout from "../../../layout/SinglePageLayout";
import { Button, Table, message, Modal } from "antd";
import { useEffect, useState } from "react";
import axiosInstance from "../../../variables/api/axiosInstance";
import { TOKEN } from "../../../variables/constants";
import AddProduitAttestation from "./AddProduitAttestation";
import moment from "moment";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import ActionDropdown from "../../production/components/ActionDropdown";

const ProduitAttestation = () => {
  const [categories, setCategories] = useState([]);
  const [reload, setReload] = useState(false);
  const [orderModalOpen, setOrderModalOpen] = useState(false);
  const [produits, setProduits] = useState([]);
  const [loadingProducts, setLoadingProducts] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);

  // Récupération des données
  useEffect(() => {
    setLoadingProducts(true);
    axiosInstance
      .get(`/api/produit-attestation`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      })
      .then((res) => {
        setProduits(res.data.reverse());
        setLoadingProducts(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        message.error("Erreur lors du chargement des produits.");
        setLoadingProducts(false);
      });

    axiosInstance
      .get(`/api/categorie`, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      })
      .then((res) => setCategories(res.data))
      .catch(console.error);
  }, [reload]);

  // Ajout ou modification
  const handleAddEditProduct = async (values) => {
    try {
      if (editingProduct) {
        await axiosInstance.put(
          `/api/produit-attestation/${editingProduct.codeId}`,
          values,
          {
            headers: { Authorization: `Bearer ${TOKEN}` },
          }
        );
        message.success("Produit mis à jour avec succès !");
      } else {
        const isDuplicate = produits.some(
          (p) =>
            p.typeAttestation.toLowerCase() ===
            values.typeAttestation.toLowerCase()
        );
        if (isDuplicate) {
          message.warning(
            "Un produit avec ce nom existe déjà. Veuillez utiliser un nom différent."
          );
          return;
        }
        await axiosInstance.post("/api/produit-attestation", values, {
          headers: { Authorization: `Bearer ${TOKEN}` },
        });
        message.success("Produit ajouté avec succès !");
      }

      setOrderModalOpen(false);
      setEditingProduct(null);
      setReload((prev) => !prev);
    } catch (error) {
      console.error("Error adding/editing product:", error);
      message.error(
        editingProduct
          ? "Échec de la mise à jour du produit."
          : "Échec de l'ajout du produit."
      );
    }
  };

  // Suppression
  const handleDeleteProduct = async (codeId) => {
    try {
      await axiosInstance.delete(`/api/produit-attestation/${codeId}`, {
        headers: { Authorization: `Bearer ${TOKEN}` },
      });
      message.success("Produit supprimé avec succès !");
      setReload((prevState) => !prevState);
    } catch (error) {
      console.error("Error deleting product:", error);
      message.error("Échec de la suppression du produit.");
    }
  };

  const handleEditClick = (record) => {
    setEditingProduct(record);
    setOrderModalOpen(true);
  };

  const handleNewProductClick = () => {
    setEditingProduct(null);
    setOrderModalOpen(true);
  };

  // Table
  const columns = [
    {
      title: "Produit",
      key: "produit",
      render: (_, record) => `${record.typeAttestation}`,
    },
    {
      title: "P.U.",
      dataIndex: "montant",
      key: "montant",
    },
    {
      title: "Categorie(s)",
      dataIndex: "categories",
      key: "categories",
      render: (categories) => categories.map((cat) => cat.nom).join("; "),
    },
    {
      title: "Date de création",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (date) =>
        date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "N/A",
    },
    {
      title: "Date de mise à jour",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (date) =>
        date ? moment(date).format("YYYY-MM-DD HH:mm:ss") : "N/A",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <ActionDropdown
          actions={[
            {
              key: "edit",
              label: "Modifier",
              icon: <EditOutlined />,
              onClick: () => handleEditClick(record),
            },
            {
              key: "delete",
              label: "Supprimer",
              icon: <DeleteOutlined />,
              danger: true,
              onClick: () =>
                Modal.confirm({
                  title: "Êtes-vous sûr de vouloir supprimer ce produit ?",
                  okText: "Oui",
                  cancelText: "Non",
                  okType: "danger",
                  onOk: () => handleDeleteProduct(record.codeId),
                }),
            },
          ]}
        />
      ),
    },
  ];

  return (
    <SinglePageLayout>
      <div>
        <Button
          onClick={handleNewProductClick}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          Nouveau produit
        </Button>
        <Table
          dataSource={produits}
          columns={columns}
          rowKey="codeId" // ✅ Important : identifiant unique
          loading={loadingProducts}
          pagination={{ showSizeChanger: true }}
        />
      </div>

      <AddProduitAttestation
        orderModalOpen={orderModalOpen}
        setOrderModalOpen={setOrderModalOpen}
        categories={categories}
        onSubmitCommandeAttestation={handleAddEditProduct}
        editingProduct={editingProduct}
      />
    </SinglePageLayout>
  );
};

export default ProduitAttestation;
